import { ClassName } from '@type/component-data-types'
import React from 'react'

type Props = {
  children?: React.ReactNode
  className?: ClassName
}

const ArticleRead = React.memo((props: Props): React.JSX.Element => {
  const className = props.className
    ? `article__read ${props.className}`
    : `article__read`

  return <div className={className}>{props.children}</div>
})
export default ArticleRead
